import { Stack } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import MuiTextField from "../../common/text-field/MuiTextField";
import { useFormik } from "formik";
import * as Yup from "yup";
import { BroadcastingUpdateRequest } from "../../../services/Endpoints/broadcast/BroadcastingUpdateEndpoint";
import errorResolver from "../../../utils/error-resolver";
import { useNotificationContext } from "../../../context/notificationContext";
import { useProtectedAxiosInstance } from "../../../hooks/axiosInstance";
import { useState } from "react";

interface IBroadcastingEditFormProps {
  id: number | null;
  pickupCount: number;
  pickupLoopCounter: number;
  onClose: () => void;
  onSuccess: () => void;
}

export default function BroadcastingPickupEditForm({
  id,
  pickupCount,
  pickupLoopCounter,
  onClose,
  onSuccess,
}: IBroadcastingEditFormProps) {
  const protectedInstance = useProtectedAxiosInstance();
  const { setNotification } = useNotificationContext();
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      pickupCount,
      pickupLoopCounter,
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      pickupCount: Yup.number()
        .required("تعداد کل دفعات برداشت الزامی است")
        .min(1, "عدد باید بزرگتر از ۰ باشد"),
      pickupLoopCounter: Yup.number()
        .required("تعداد برداشت در هر دفعه الزامی است")
        .min(1, "عدد باید بزرگتر از ۰ باشد"),
    }),
    onSubmit: async (values) => {
      try {
        setLoading(true);
        const req = new BroadcastingUpdateRequest(protectedInstance);
        await req.update(id ?? 1, {
          pickup_loop_counter: +values.pickupLoopCounter,
          pickup_count: +values.pickupCount,
        });

        onSuccess();
        onClose();
      } catch (error) {
        errorResolver({ error, setNotification });
        console.error(error);
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <Stack gap="20px" p="20px">
        <MuiTextField
          width="100%"
          name="pickupCount"
          type="text"
          label="تعداد کل دفعات برداشت"
          placeholder="تعداد کل دفعات برداشت را وارد کنید"
          value={formik.values.pickupCount.toString()}
          handleChange={formik.handleChange}
          error={
            formik.touched.pickupCount && Boolean(formik.errors.pickupCount)
          }
        />

        <MuiTextField
          width="100%"
          name="pickupLoopCounter"
          type="text"
          label="تعداد برداشت در هر دفعه"
          placeholder="تعداد برداشت در هر دفعه را وارد کنید"
          value={formik.values.pickupLoopCounter.toString()}
          handleChange={formik.handleChange}
          error={
            formik.touched.pickupLoopCounter &&
            Boolean(formik.errors.pickupLoopCounter)
          }
        />

        <LoadingButton type="submit" variant="confirm" loading={loading}>
          تایید
        </LoadingButton>
      </Stack>
    </form>
  );
}
